import { useEffect } from 'react';
import { useMenu } from '../utils/BurgerMenuContexte.tsx';
import gsap from 'gsap';

function PagerMover() {
    const { isBurgerMenuOpened } = useMenu();

    useEffect(() => {
        const targets = document.querySelectorAll('.page-content');

        // ✅ Vérifier qu'il y a au moins un élément
        if (!targets || targets.length === 0) return;

        if (isBurgerMenuOpened) {
            gsap.to(targets, {
                xPercent: -100,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1,
                opacity: 0,
            });
        } else {
            gsap.to(targets, {
                delay: 0.5,
                xPercent: 0,
                duration: 0.5,
                ease: 'power1.in',
                stagger: 0.1,
                opacity: 1,
            });
        }
    }, [isBurgerMenuOpened]);

    return null;
}

export default PagerMover;
